import candidateManagementService from '@/api/candidate-management.service'

const actions = {
  getCompanyCandidateList(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .getCompanyCandidateList(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  addInternalRef(context, data) {
    return new Promise((resolve, reject) => {
      candidateManagementService
        .addRefrence(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  getAppliedCandidateList(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .getAppliedCandidateList(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getBothCandidateList(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .getBothCandidateList(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getAppliedList(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .getAppliedList(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  deleteApplicant: (context, deleteApplicant) => {
    let deletedCandidate = new Promise((resolve, reject) => {
      candidateManagementService
        .deleteApplicant(context, deleteApplicant)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return deletedCandidate
  },
  getJobCodeAppliedCandidateComments(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .getJobCodeAppliedCandidateComments(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  sendCandidateComment(context, data) {
    var promise = new Promise((resolve, reject) => {
      candidateManagementService
        .sendCandidateComment(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  statusList(context) {
    return new Promise((resolve, reject) => {
      candidateManagementService
        .statusList(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  setStatus(context, data) {
    return new Promise((resolve, reject) => {
      candidateManagementService
        .setStatus(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  generateShareLink(context, payload) {
    return new Promise((resolve, reject) => {
      candidateManagementService
        .generateShareLink(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  getSharedCandidateLink(context, payload) {
    return new Promise((resolve, reject) => {
      candidateManagementService
        .getSharedCandidateLink(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
}

export default actions
